import React from "react";
import PageHeader from "../components/marketing/PageHeader";
import Gallery from "../components/marketing/Gallery";
import { useContent } from "../context/ContentContext";

export default function GalleryPage() {
  const { gallery } = useContent();
  return (
    <div data-testid="gallery-page">
      <PageHeader
        overline="Moments on Stage"
        title={<>The <span className="italic gold-gradient-text">gallery</span>.</>}
        subtitle="A glimpse into performances, workshops and the everyday grace of our dancers."
        image="https://images.pexels.com/photos/30481580/pexels-photo-30481580.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
      />
      <Gallery items={gallery} heading={false} />
    </div>
  );
}
